<template>
  <div class="links-wrapper">
    <router-link
      v-for="item in menu"
      :key="item.type"
      class="links-wrapper-item"
      :to="`/${item.type}`"
    >
      {{ $t(`ui.button.${item.text}`) }}
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menu: [
        { text: 'legalWarning', type: 'legal' },
        { text: 'privacyPolicy', type: 'privacy' },
        { text: 'cookiesPolicy', type: 'cookies' }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.links-wrapper {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  padding-bottom: 40px;

  &-item {
    @include themify($themes) {
      color: themed('buttonColorPrimaryType');
    }
    &:hover {
      @include themify($themes) {
        color: tint(themed('buttonColorPrimaryType'), 30%);
      }
    }
  }
}
</style>
